export default {
  common: {
    view: 'Открыть',
    save: 'Сохранить',
    cancel: 'Отмена',
    delete: 'Удалить',
    reset: 'Удалить',
    edit: 'Редактировать',
    create: 'Создать',
    close: 'Закрыть',
    next: 'Далее',
    back: 'Назад',
    search: 'Поиск',
    upload: 'Загрузить',
    download: 'Скачать',
    downloadAll: 'Скачать всё',
    confirm: 'Подтвердить',
    all: 'Все',
    loading: 'Загрузка...',
    noData: 'Данные не найдены',
    error: 'Ошибка',
    success: 'Успешно',
  },

  layout: {
    savat: 'Корзина',
    dv: "Green Card (DV)",
    brand: 'Oasis Visa CRM',
    dashboard: 'Главная',
    tasks: 'Задачи',
    clients: 'Клиенты',
    tekshiruv: 'Проверка',
    vacancies: 'Вакансии',
    partners: 'Партнёры',
    employees: 'Сотрудники',
    monitoring: 'Мониторинг',
    settings: 'Настройки',
    profile: 'Профиль',
    logout: 'Выход',
    logoutSuccess: 'Вы вышли из системы',
    newClient: 'Новый клиент',
    botSurveys: 'Анкеты из бота',
    cvBuilder: 'CV Builder',
    emailMarketing: 'Email-маркетинг',
    scrapedJobs: 'Объявления работ',
    calendar: 'Календарь',
    notifications: 'Уведомления',
    admin: 'Администратор',
    employee: 'Сотрудник',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    cases: 'Дела (Cases)',
    casesDashboard: 'Дашборд (Cases)',
  },

  notifications: {
    title: 'Уведомления',
    all: 'Все',
    unread: 'Непрочитанные',
    tasks: 'Задачи',
    system: 'Система',
    markAllRead: 'Отметить все прочитанными',
    cleanOld: 'Очистить старые',
    viewAll: 'Смотреть все',
    telegramUlash: 'Подключить Telegram',
    telegramUlangan: 'Telegram подключён',
    telegramUzish: 'Нажмите, чтобы отключить Telegram',
    telegramYoriqnoma: 'Откройте бота в Telegram и нажмите «Start» — ссылка действует {n} мин.',
    telegramXato: 'Не удалось подключить Telegram — попробуйте позже',
    noNotifications: 'Уведомлений нет',
    noUnread: 'Нет непрочитанных уведомлений',
    markAsRead: 'Отметить прочитанным',
    deleteNotif: 'Удалить',
    now: 'Только что',
    minutesAgo: '{n} мин. назад',
    hoursAgo: '{n} ч. назад',
    daysAgo: '{n} дн. назад',
    markAllSuccess: 'Все уведомления отмечены как прочитанные',
    errorGeneric: 'Произошла ошибка',
    confirmClean: 'Прочитанные уведомления старше 30 дней будут удалены. Продолжить?',
    confirmCleanTitle: 'Подтверждение',
    yesDelete: 'Да, удалить',
    cancelBtn: 'Отмена',
    typeTask: 'Задача',
    typeCompleted: 'Выполнено',
    typeApproved: 'Утверждено',
    typeOverdue: 'Просрочено',
    typeComment: 'Комментарий',
    typeClient: 'Клиент',
    typeSystem: 'Система',
    typeReminder: 'Напоминание',
    newVacancy: 'Новая вакансия на предприятии!',
    taskCompleted: 'Задача выполнена',
    taskAssigned: 'Задача назначена',
    taskReviewed: 'Задача рассмотрена',
    callbackInMinutes: 'Перезвонить (через {n} мин.)',
    callbackOn: 'Перезвонить: {name}',
    taskDoneBy: 'Задача "{task}" выполнена пользователем {user}',
    callNoAnswer: 'Не ответил',
    callCallback: 'Перезвонить',
    callAnswered: 'Ответил',
    callBusy: 'Занят',
    callSuccess: 'Успешно',
    callRejected: 'Отказ',
  },

  calendar: {
    today: 'Сегодня',
    allStatuses: 'Все статусы',
    allPriorities: 'Все приоритеты',
    more: 'ещё',
    noEvents: 'Нет событий',
    tasks: 'задач',
    startDate: 'Начало',
    dueDate: 'Срок',
    dueTime: 'Время',
    assignee: 'Исполнитель',
    description: 'Описание',
    goToTask: 'Перейти к задаче',
    viewMonth: 'Месяц',
    viewWeek: 'Неделя',
    viewList: 'Список',
    statusNew: 'Новый',
    statusInProgress: 'В процессе',
    statusCompleted: 'Выполнено',
    statusApproved: 'Одобрено',
    prioLow: 'Низкий',
    prioMedium: 'Средний',
    prioHigh: 'Высокий',
    prioUrgent: 'Срочно',
    dayMon: 'Пн', dayTue: 'Вт', dayWed: 'Ср', dayThu: 'Чт', dayFri: 'Пт', daySat: 'Сб', daySun: 'Вс',
    shortSun: 'Вс', shortMon: 'Пн', shortTue: 'Вт', shortWed: 'Ср', shortThu: 'Чт', shortFri: 'Пт', shortSat: 'Сб',
    monthShortJan: 'Янв', monthShortFeb: 'Фев', monthShortMar: 'Мар', monthShortApr: 'Апр',
    monthShortMay: 'Май', monthShortJun: 'Июн', monthShortJul: 'Июл', monthShortAug: 'Авг',
    monthShortSep: 'Сен', monthShortOct: 'Окт', monthShortNov: 'Ноя', monthShortDec: 'Дек',
    monthJan: 'Январь', monthFeb: 'Февраль', monthMar: 'Март', monthApr: 'Апрель',
    monthMay: 'Май', monthJun: 'Июнь', monthJul: 'Июль', monthAug: 'Август',
    monthSep: 'Сентябрь', monthOct: 'Октябрь', monthNov: 'Ноябрь', monthDec: 'Декабрь',
    addEvent: 'Добавить событие',
    eventName: 'Название',
    eventNamePh: 'Название события',
    dateLabel: 'Дата',
    timeLabel: 'Время',
    priorityLabel: 'Приоритет',
    visibility: 'Видимость',
    onlyMe: 'Только мне',
    everyone: 'Всем',
    selectEmployee: 'Выберите сотрудника',
    noteLabel: 'Заметка',
    notePh: 'Дополнительная заметка...',
    cancel: 'Отмена',
    save: 'Сохранить',
    eventSaved: 'Событие сохранено!',
    eventDeleted: 'Событие удалено',
    errorGeneric: 'Произошла ошибка',
    confirmDeleteTitle: 'Удалить',
    confirmDeleteMsg: 'Удалить событие "{title}"?',
    yes: 'Да',
    createdBy: 'Автор',
    adminBadge: 'Руководитель',
    goToVacancy: 'Перейти к вакансии',
    deleteBtn: 'Удалить',
  },

  login: {
    title: 'AgentsVA CRM',
    subtitle: 'Вход в систему',
    username: 'Логин',
    password: 'Пароль',
    loginButton: 'Войти',
    loggingIn: 'Вход...',
    welcome: 'Добро пожаловать!',
    invalidCredentials: 'Неверный логин или пароль',
    usernameRequired: 'Введите логин',
    passwordRequired: 'Введите пароль',
  },

  dashboard: {
    totalTasks: 'Всего задач',
    approved: 'Подтверждено',
    inProgress: 'В процессе',
    totalClients: 'Всего клиентов',
    recentTasks: 'Последние задачи',
    recentClients: 'Последние клиенты',
    task: 'Задача',
    status: 'Статус',
    firstName: 'Имя',
    lastName: 'Фамилия',
    country: 'Страна',
    viewAll: 'Посмотреть все',
    loadError: 'Ошибка загрузки данных',
    quickActions: 'Быстрые действия',
    addClient: 'Новый клиент',
    viewVacancies: 'Вакансии',
    cvBuilder: 'Создать CV',
    botSurveys: 'Анкеты бота',
    noTasks: 'Задач нет',
    noClients: 'Клиентов нет',
    statTasks: 'Задачи',
    statNew: 'Новые',
    statInProgress: 'В процессе',
    statApproved: 'Подтверждённые',
    statClients: 'Клиенты',
    statVacancies: 'Вакансии',
    statMyPartners: 'Мои партнёры',
    statMyClients: 'Мои клиенты',
    allLink: 'Все',
    greetingNight: 'Доброй ночи',
    greetingMorning: 'Доброе утро',
    greetingDay: 'Добрый день',
    greetingEvening: 'Добрый вечер',
    monthJan: 'Январь', monthFeb: 'Февраль', monthMar: 'Март', monthApr: 'Апрель',
    monthMay: 'Май', monthJun: 'Июнь', monthJul: 'Июль', monthAug: 'Август',
    monthSep: 'Сентябрь', monthOct: 'Октябрь', monthNov: 'Ноябрь', monthDec: 'Декабрь',
    daySun: 'Воскресенье', dayMon: 'Понедельник', dayTue: 'Вторник', dayWed: 'Среда',
    dayThu: 'Четверг', dayFri: 'Пятница', daySat: 'Суббота',
    cStatusYangi: 'Новый',
    cStatusHujjat: 'Документы',
    cStatusTayyor: 'Готово',
    cStatusKutilmoqda: 'Ожидание',
    cStatusVizaOldi: 'Виза получена',
    cStatusJonatildi: 'Отправлен',
    cStatusBekor: 'Отменён',
  },

  chat: {
    title: 'Чат',
    searchPlaceholder: 'Поиск...',
    searchChat: 'Поиск чатов...',
    newChat: 'Новый чат',
    newGroup: 'Новая группа',
    myChats: 'Мои чаты',
    allChats: 'Все',
    noChats: 'Нет чатов',
    noMessages: 'Нет сообщений',
    typeMessage: 'Напишите сообщение...',
    send: 'Отправить',
    attach: 'Прикрепить файл',
    emoji: 'Эмодзи',
    mention: 'Упоминание',
    share: 'Поделиться',
    shareVacancy: 'Поделиться вакансией',
    shareClient: 'Поделиться клиентом',
    selectMember: 'Выберите участника',
    addMember: 'Добавить участника',
    removeMember: 'Удалить участника',
    leaveGroup: 'Выйти из группы',
    deleteChat: 'Удалить чат',
    chatName: 'Название чата',
    groupName: 'Название группы',
    members: 'Участники',
    membersCount: '{count} участников',
    online: 'В сети',
    offline: 'Не в сети',
    typing: 'Печатает...',
    edit: 'Изменить',
    delete: 'Удалить',
    reply: 'Ответить',
    copy: 'Копировать',
    forward: 'Переслать',
    messageDeleted: 'Сообщение удалено',
    messageEdited: 'изменено',
    confirmDeleteMsg: 'Удалить это сообщение?',
    confirmDeleteChat: 'Удалить этот чат?',
    confirmLeaveGroup: 'Выйти из этой группы?',
    chatCreated: 'Чат создан',
    createError: 'Ошибка создания чата',
    sendError: 'Ошибка отправки сообщения',
    fileTooLarge: 'Файл слишком большой (макс. 25 МБ)',
    fileUploadError: 'Ошибка загрузки файла',
    searchUser: 'Поиск сотрудника...',
    select: 'Выбрать',
    createChat: 'Создать чат',
    create: 'Создать',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    today: 'Сегодня',
    yesterday: 'Вчера',
    selectChat: 'Выберите чат',
    selectChatHint: 'Выберите чат слева, чтобы начать общение',
    groupInfo: 'О группе',
    privateChat: 'Личный чат',
    groupChat: 'Групповой чат',
    me: 'Я',
    you: 'Вы',
    unreadMessages: 'непрочитанных сообщений',
    replyTo: 'Ответ',
    writeMessage: 'Напишите сообщение...',
    uploadImage: 'Загрузить изображение',
    uploadFile: 'Загрузить файл',
    sharedVacancy: 'Вакансия',
    sharedClient: 'Клиент',
    viewDetails: 'Подробнее',
    addEmoji: 'Добавить эмодзи',
    loadingMessages: 'Загрузка сообщений...',
    loadMore: 'Загрузить ещё',
    photo: 'Фото',
    file: 'Файл',
    noResults: 'Ничего не найдено',
    groupsSection: 'Группы',
    privateSection: 'Личные чаты',
    messagesShort: 'сообщ.',
    emptyShort: 'пусто',
    settings: 'Настройки',
    retry: 'Повторить',
    attachImageFile: 'Фото/файл',
    vacancyKind: 'Вакансия',
    clientKind: 'Клиент',
    searchVacancyPlaceholder: 'Поиск вакансии...',
    searchClientPlaceholder: 'Имя/фамилия клиента...',
    enterSearchHint: 'Введите поисковый запрос',
    addMemberPh: 'Добавить участника...',
    addBtn: 'Добавить',
    removeBtn: 'Удалить',
    adminTag: 'Админ',
    saveBtn: 'Сохранить',
    clearMessages: 'Очистить переписку',
    deleteAllMessages: 'Удалить все сообщения',
    dangerZone: 'Опасная зона',
    deleteChatCompletely: 'Удалить чат полностью',
    adminCleanup: 'Админ: Удалить старые сообщения',
    olderThan: 'Старше {n} дней',
    deleteAllNow: 'Удалить все сейчас',
    editMessage: 'Редактировать сообщение',
  },

  partners: {
    title: 'Партнёры',
    total: 'Всего',
    statusNew: 'Новый',
    statusRegular: 'Постоянный',
    statusPremium: 'Премиум',
    statusVip: 'VIP',
    dirWork: 'Работа',
    dirStudy: 'Образование',
    dirTravel: 'Туризм',
    dirAvia: 'Авиа',
    filterAll: 'Все',
    filterDir: 'Направление',
    filterCountry: 'Страна',
    filterStatusLabel: 'Статус',
    filterCategory: 'Категория',
    filterEmployee: 'Сотрудник',
    partnerStatusTitle: 'Статус партнёрства',
    trustLevel: 'Надёжность',
    category: 'Категория',
    employee: 'Сотрудник',
    categoryAgency: 'Агентство',
    categoryDirect: 'Напрямую',
    categoryScammer: 'Мошенник',
    categoryUnknown: 'Неизвестно',
    vacancyLabel: 'Вакансия',
    vacancyName: 'Название вакансии',
    companyName: 'Компания',
    dateLabel: 'Дата',
    vacancyDescription: 'Дополнительная информация...',
    saveFilter: 'Сохранить фильтр',
    removeFilter: 'Удалить фильтр',
    addPartner: 'Добавить партнёра',
    editPartner: 'Изменить партнёра',
    partnerAddSuccess: 'Партнёр добавлен',
    partnerAlreadyExists: 'Этот контакт уже в списке партнёров: "{name}"',
    confirmRemove: 'Отменить партнёрство с "{title}"?',
    confirmRemoveTitle: 'Отмена партнёрства',
    yesRemove: 'Да, отменить',
    noCancel: 'Нет',
    removeSuccess: 'Партнёрство отменено',
    bulkSelected: 'Выбрано: {count}',
    bulkAssignEmployees: 'Сотрудники',
    bulkNotAssigned: '— Не закреплено —',
    bulkAssignBtn: 'Закрепить',
    bulkAssignSuccess: 'Закреплено партнёров: {count}',
    bulkAssignCancelled: 'Закрепление отменено',
    saved: 'Сохранено',
    errorGeneric: 'Произошла ошибка',
    totalVacancies: 'Всего вакансий',
    activePartners: 'Активные партнёры',
    assigned: 'Закреплённые',
    newPartner: 'Новый партнёр',
    searchPlaceholder: 'Вакансия, компания, город...',
    companyName: 'Название компании',
    contactPerson: 'Контактное лицо',
    phone: 'Телефон',
    email: 'Email',
    website: 'Веб-сайт',
    address: 'Адрес',
    country: 'Страна',
    city: 'Город',
    jobTitle: 'Название вакансии',
    description: 'Описание',
    notes: 'Заметки',
    status: 'Статус',
    assignedTo: 'Закреплён за',
    additionalAssignees: 'Доп. сотрудники',
    linkedClients: 'Прикреплённые клиенты',
    linkClient: 'Прикрепить клиента',
    unlinkClient: 'Открепить клиента',
    selectClients: 'Выберите клиентов',
    noLinkedClients: 'Нет прикреплённых клиентов',
    multiAssignTitle: 'Назначение нескольких сотрудников',
    selectAssignees: 'Выберите сотрудников',
    assignPartner: 'Закрепить партнёра',
    assignPartnerHint: 'Эта вакансия закреплена за вами',
    callPhone: 'Позвонить',
    sendEmail: 'Отправить Email',
    openWebsite: 'Открыть сайт',
    view: 'Просмотр',
    edit: 'Изменить',
    delete: 'Удалить',
    save: 'Сохранить',
    cancel: 'Отмена',
    confirmDelete: 'Удалить этого партнёра?',
    confirmUnlink: 'Открепить клиента?',
    deleteSuccess: 'Партнёр удалён',
    deleteError: 'Ошибка удаления',
    saveSuccess: 'Сохранено',
    saveError: 'Ошибка сохранения',
    assignSuccess: 'Закреплено',
    assignError: 'Ошибка закрепления',
    linkSuccess: 'Клиент прикреплён',
    unlinkSuccess: 'Клиент откреплён',
    noPartners: 'Партнёров нет',
    loadError: 'Ошибка загрузки данных',
    openDetails: 'Подробнее',
    close: 'Закрыть',
    postedAt: 'Дата публикации',
    source: 'Источник',
    sourceLink: 'Ссылка',
    category: 'Категория',
    myPartners: 'Мои партнёры',
    allPartners: 'Все партнёры',
    filterCountry: 'По стране',
    filterStatus: 'По статусу',
    actions: 'Действия',
    viewVacancy: 'Посмотреть вакансию',
    assigneeLabel: 'Закреплённый сотрудник',
    additionalLabel: 'Доп. сотрудники',
    noAssignee: 'Не закреплён',
    selectClientsPlaceholder: 'Найдите и выберите клиентов',
    clientSelected: 'Выбрано клиентов: {count}',
    apply: 'Применить',
  },

  status: {
    new: 'Новый',
    in_progress: 'В процессе',
    completed: 'Выполнено',
    approved: 'Подтверждено',
  },

  priority: {
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    urgent: 'Срочный',
  },

  tasks: {
    title: 'Задачи',
    newTask: 'Новая задача',
    all: 'Все',
    new: 'Новые',
    inProgress: 'В процессе',
    completed: 'Выполненные',
    approved: 'Подтверждённые',
    employee: 'Сотрудник',
    statusCol: 'Статус',
    priorityCol: 'Приоритет',
    deadline: 'Срок',
    actions: 'Действия',
    start: 'Начать',
    complete: 'Выполнить',
    approve: 'Подтвердить',
    taskStarted: 'Задача начата',
    confirmComplete: 'Отметить задачу как выполненную?',
    confirmCompleteTitle: 'Подтверждение',
    taskCompleted: 'Задача выполнена',
    confirmApprove: 'Подтвердить задачу?',
    confirmApproveTitle: 'Подтверждение',
    taskApproved: 'Задача подтверждена',
    noTasks: 'Нет задач',
  },

  taskDetail: {
    result: 'Результат работы',
    noResult: 'Результат не загружен',
    addResult: 'Файл / скриншот',
    resultHint: 'Файл или скриншот, подтверждающий выполнение',
    resultUploaded: 'Результат загружен',
    resultPartial: '{n} файл(ов) не загружено',
    resultDeleted: 'Результат удалён',
    deleteResultConfirm: '{name} будет удалён. Продолжить?',
    description: 'Описание',
    assignedTo: 'Назначен',
    createdBy: 'Создал',
    startDate: 'Дата начала',
    dueDate: 'Срок',
    createdAt: 'Дата создания',
    completedAt: 'Дата выполнения',
    comments: 'Комментарии',
    noComments: 'Нет комментариев',
    addComment: 'Напишите комментарий...',
    send: 'Отправить',
    commentAdded: 'Комментарий добавлен',
  },

  taskCreate: {
    title: 'Создать новую задачу',
    taskName: 'Название задачи',
    description: 'Описание',
    employee: 'Сотрудник',
    employeePlaceholder: 'Выберите сотрудника',
    priority: 'Приоритет',
    startDate: 'Дата начала',
    dueDate: 'Дата срока',
    dueTime: 'Время срока',
    create: 'Создать',
    cancel: 'Отмена',
    taskNameRequired: 'Введите название задачи',
    descriptionRequired: 'Введите описание',
    employeeRequired: 'Выберите сотрудника',
    startDateRequired: 'Выберите дату начала',
    dueDateRequired: 'Выберите дату срока',
    dueTimeRequired: 'Выберите время срока',
    createSuccess: 'Задача создана',
    createError: 'Ошибка создания задачи',
    loadEmployeesError: 'Ошибка загрузки сотрудников',
  },

  slot: {
    title: 'Слот',
    ustun: 'Слот',
    yoq: 'Слот ещё не получен — когда получите, внесите сюда: дату, время и место',
    qosh: 'Добавить слот',
    qoshYana: 'Добавить ещё слот',
    joyYoq: 'Место не указано',
    joyMisol: 'Например: посольство Эстонии или VFS Global (Ташкент)',
    anketa: 'Анкета',
    bordi: 'Пришёл',
    kelmadi: 'Не пришёл',
    kochir: 'Перенести',
    tahrir: 'Изменить',
    bekor: 'Отменить',
    yana: 'Другие действия',
    bekorSavol: 'Отменить слот? Напоминания прекратятся.',
    tarix: 'Другие слоты ({n})',
    sana: 'Дата',
    soat: 'Время',
    joy: 'Место (посольство / визовый центр)',
    manzil: 'Адрес',
    maqsad: 'Цель',
    izoh: 'Комментарий',
    saqlandi: 'Слот сохранён — напоминания отправляются автоматически',
    holatQoyildi: 'Статус отмечен',
    xato: 'Не сохранено',
    shakl: { yangi: 'Новый слот', tahrir: 'Изменить слот', kochir: 'Перенос слота — новая дата' },
    maqsadlar: { topshirish: 'Подача документов', biometrika: 'Биометрия', intervyu: 'Собеседование', olish: 'Получение паспорта / визы' },
    qoldi: { otdi: 'Время прошло — отметьте статус', bugun: 'Сегодня, {soat}', ertaga: 'Завтра, {soat}', kun: 'Осталось {n} дн.' },
  },
  tekshiruv: {
    title: 'Очередь проверки',
    subtitle: 'Значения, автоматически записанные в карточку из документов, которые сотрудник ещё не видел. Сверьте с документом: верно — подтвердите, ошибка — исправьте или выберите другое значение из документа. В анкету должны попадать только проверенные данные.',
    kimniki: 'Какие клиенты',
    daraja: 'Уровень доверия',
    mening: 'Мои клиенты',
    barcha: 'Все клиенты',
    hammasi: 'Все',
    jami: '{n} знач. · {m} клиент(ов)',
    bosh: 'Нечего проверять — всё просмотрено',
    boshMening: 'У ваших клиентов нечего проверять',
    masul: 'Ответственный: {name}',
    hujjat: 'Исходный документ',
    pdfOch: 'Открыть PDF',
    togri: 'Верно',
    yuqorilar: 'Подтвердить высокие ({n})',
    tasdiqlandi: 'Подтверждено: {n}',
    saqlandi: 'Исправлено и сохранено',
    tanlandi: '{field}: записано значение из документа',
    xato: 'Не сохранено — попробуйте ещё раз',
  },
  savat: {
    title: 'Корзина',
    subtitle: 'Удалённые клиенты хранятся здесь — с документами, фактами и кейсами. «Вернуть» '
      + 'восстанавливает их одним нажатием.',
    bosh: 'Корзина пуста',
    mijoz: 'Клиент',
    qachon: 'Удалён',
    kim: 'Кто удалил',
    hujjatlar: 'Документы',
    qaytarish: 'Вернуть',
    qaytarildi: '{ism} восстановлен',
    faqatAdmin: 'Корзина доступна только администратору',
  },
  hujjatSavat: {
    tugma: 'Корзина ({n})',
    title: 'Корзина документов',
    subtitle: 'Удалённые документы хранятся здесь — с файлом и распознанными данными. «Вернуть» возвращает '
      + 'документ на место. Документ в корзине не виден анкете, CC и Claude.',
    bosh: 'Корзина пуста',
    qachon: 'Удалён',
    kim: 'Кто удалил',
    sabab: 'Причина',
    korish: 'Открыть',
    qaytarish: 'Вернуть',
    qaytarildi: '{tur}: возвращён',
    butunlay: 'Удалить навсегда',
    butunlayTasdiq: 'Документ и файл будут удалены НАВСЕГДА — вернуть нельзя. Для подтверждения введите «{soz}»:',
    sozMosEmas: 'Слово подтверждения не совпадает',
    ochirildi: 'Документ удалён навсегда',
  },
  clients: {
    olaman: 'Беру себе',
    olindi: 'Клиент закреплён за вами',
    allaqachonOlingan: 'Этого клиента уже взял другой сотрудник: {kim}',
    savatgaTasdiq: 'Клиент попадёт в корзину — его можно вернуть одним нажатием в разделе «Корзина». '
      + 'Для подтверждения введите полное имя клиента: {ism}',
    savatgaTashlash: 'В корзину',
    ismMosEmas: 'Имя не совпадает — введите имя и фамилию клиента',
    savatgaTushdi: '{ism} перемещён в корзину — можно вернуть из «Корзины»',
    bulkLinkSuccess: 'Клиентов привязано к партнёрам: {clients} / {partners}',
    bulkAssignSuccess: 'Закреплено клиентов: {count}',
    bulkAssignCancelled: 'Закрепление отменено',
    bulkNotAssigned: '— Не закреплено —',
    employeesLabel: 'Сотрудники',
    assignBtn: 'Закрепить',
    linkToPartner: 'Привязать к партнёру',
    selectedCount: 'Выбрано: {count}',
    errorGeneric: 'Ошибка',
    title: 'Клиенты',
    scope: {
      label: 'Какие клиенты',
      all: 'Все клиенты',
      mine: 'Мои клиенты',
      mineHint: 'Клиенты, закреплённые за вами — как основной ответственный или как дополнительный сотрудник',
      co: 'доп.',
      coHint: 'Вы дополнительно закреплены за этим клиентом (основной ответственный — другой сотрудник)',
      mineEmpty: 'За вами пока не закреплено ни одного клиента',
    },
    newClient: 'Новый клиент',
    searchPlaceholder: 'Имя, паспорт, телефон...',
    fullName: 'ФИО',
    passport: 'Паспорт',
    phone: 'Телефон',
    country: 'Страна',
    travelPurpose: 'Цель',
    direction: 'Направление',
    status: 'Статус',
    employee: 'Сотрудник',
    all: 'Все',
    registeredBy: 'Зарегистрировал',
    date: 'Дата',
    actions: 'Действия',
    view: 'Просмотр',
    delete: 'Удалить',
    confirmDelete: 'Вы хотите удалить этого клиента?',
    confirmDeleteTitle: 'Подтверждение',
    deleteSuccess: 'Клиент удалён',
    searchError: 'Ошибка поиска',
    noSearchResults: 'Ничего не найдено',
    noClients: 'Клиентов нет',
    uploadPhoto: 'Загрузить фото (нажмите)',
    photoUploaded: 'Фото успешно загружено',
    photoUploadError: 'Ошибка загрузки фото',
    workInfo: 'Работа / ВУЗ',
    notes: 'Заметки',
    addNote: 'Добавить заметку...',
    noteSaved: 'Заметка сохранена',
    noteError: 'Ошибка сохранения заметки',
    noWorkInfo: '\u2014',
    ov: {
      total: 'Всего клиентов',
      totalSub: '{countries} стран · {directions} направлений',
      active: 'В работе',
      activeHint: 'Новые, сбор документов, документы готовы и ожидание визы',
      success: 'Виза получена',
      successHint: 'Виза получена и отправлены',
      cancelled: 'Отменено',
      ofTotal: '{p}% от всех клиентов',
      pipeline: 'Воронка клиентов',
      pipelineHint: 'Нажмите на этап — список отфильтруется',
      directions: 'Направления',
      countries: 'Топ стран',
      noData: 'Нет данных',
      docsMissing: 'Не хватает: {n}',
      docsComplete: 'Все собраны',
      docsMissingTitle: 'Не хватает документов:',
      stepOf: 'Этап {i} из {n}',
    },
  },

  travelPurpose: {
    work: 'Работа',
    study: 'Учёба',
    tourism: 'Туризм',
    business: 'Бизнес',
    other: 'Другое',
  },

  direction: {
    ish: 'Работа',
    oqish: 'Учёба',
    sayohat: 'Путешествие',
    biznes: 'Бизнес',
    boshqa: 'Другое',
  },

  clientStatus: {
    yangi: 'Новый',
    hujjat_yigilmoqda: 'Сбор документов',
    hujjatlar_tayyor: 'Документы готовы',
    viza_kutilmoqda: 'Ожидание визы',
    viza_oldi: 'Виза получена',
    jonatildi: 'Отправлен',
    bekor: 'Отменён',
  },

  clientDetail: {
    qoshimchaTelefonlar: 'Дополнительные телефоны',
    zagranHolati: 'Паспорт: чистый / есть штампы',
    zagranBelgilanmagan: 'Не отмечено',
    zagranToza: 'Чистый (без штампов)',
    zagranPechatBor: 'Есть штампы',
    readyToApply: 'Найдено в документе: {value} — нажмите, чтобы записать в поле',
    readyHint: 'Зелёные уже найдены в документе — нажмите, чтобы записать ({n}).',
    factSource: { mrz: 'MRZ', ai: 'ИИ', ocr: 'OCR', text: 'текст', pdf_form: 'форма', manual: 'вручную', anketa: 'анкета', xodim: 'сотрудник', claude: 'Claude', hujjat: 'документ', import: 'импорт' },
    factDocs: 'одинаково в документах: {n}',
    factConflict: 'В документах разные значения ({n}) — выберите верное (жёлтые теги)',
    factAlternative: '{source}: {value} — нажмите, чтобы записать это значение',
    fieldSource: {
      confirm: 'Подтвердить',
      levels: { tasdiqlangan: 'подтверждено', yuqori: 'высокая', orta: 'средняя', past: 'низкая' },
      tooltip: '{source} · надёжность: {level}',
      document: 'Документ: {doc}',
      holat: {
        savatda: 'Документ-источник в корзине — его можно вернуть из «Корзины» в карточке клиента',
        ochirilgan: 'Документ-источник удалён навсегда — значение осталось, его подтвердил сотрудник',
      },
      belgi: { savatda: 'в корзине', ochirilgan: 'источник удалён' },
      confirmedBy: 'Подтвердил: {who}',
      reviewHint: 'Если верно — нажмите ✓, если нет — нажмите на значение и исправьте',
      reviewTitle: 'Заполнено автоматически — проверьте',
      reviewIntro: 'Эти значения записаны из документов автоматически. Если верно — нажмите ✓, если нет — исправьте или выберите другое значение из документа.',
      confirmed: 'Подтверждено полей: {n}',
      confirmHigh: 'Подтвердить надёжные ({n})',
      alternative: 'В документе другое значение: {value} ({source}) — нажмите, чтобы записать',
      alternativesLabel: 'Другие значения:',
    },
    zagranPassport: 'Загранпаспорт',
    nationalPassport: 'Паспорт / ID карта',
    zagranSeriesHint: 'FA',
    nationalSeriesHint: 'AD',
    nationalNumberHint: 'AD2098993',
    notFoundYet: 'Пока не найдено',
    notFoundHint: 'Жёлтые — должны были найтись в документе, но не найдены. Серые — заполняются вручную. Нажмите и заполните.',
    showFull: 'Показать все данные',
    hideFull: 'Скрыть все данные',
    missing: 'Не хватает:',
    andMore: '+ ещё {n}',
    collection: 'Сбор документов',
    ifNeeded: 'если нужно',
    // Данные аккаунтов (e-mail, OneID) — пароль зашифрован
    credentials: 'Данные аккаунтов',
    credentialsHint: 'Пароли хранятся в зашифрованном виде. Просмотр пароля записывается в журнал: кто, когда, какой клиент.',
    credentialKeyMissing: 'Ключ шифрования не настроен — хранение паролей отключено. Администратору нужно добавить CREDENTIAL_KEY в .env.',
    addCredential: 'Аккаунт',
    noCredentials: 'Аккаунты не добавлены',
    credentialKind: 'Тип',
    credentialLogin: 'Логин',
    credentialPassword: 'Пароль',
    credentialNote: 'Примечание',
    credentialLoginPrompt: 'Введите логин или адрес e-mail',
    credentialLoginRequired: 'Логин не может быть пустым',
    deleteCredentialConfirm: 'Аккаунт {login} будет удалён. Продолжить?',
    credKindEmail: 'E-mail',
    credKindOneId: 'OneID',
    credKindMyGov: 'MyGov',
    credKindEmbassy: 'Портал посольства',
    credKindOther: 'Другое',
    showPassword: 'Показать пароль',
    hidePassword: 'Скрыть пароль',
    changePassword: 'Изменить пароль',
    noPassword: 'Пароля нет',
    passwordPrompt: 'Новый пароль для {login}',
    passwordPlaceholder: 'Если оставить пустым — пароль будет удалён',
    copy: 'Копировать',
    copied: 'Скопировано',
    copyFailed: 'Не удалось скопировать',
    // Личные данные из документов (0019) и визовые анкеты
    identityInfo: 'Личные данные',
    middleName: 'Отчество',
    gender: 'Пол',
    genderMale: 'Мужской',
    genderFemale: 'Женский',
    genderUnspecified: 'Не указан',
    pinfl: 'ПИНФЛ (ЖШШИР)',
    pinflHint: '14 цифр',
    birthPlace: 'Место рождения',
    birthDistrict: 'Район рождения',
    email: 'E-mail',
    passportSeries: 'Серия',
    passportSeriesHint: 'AD',
    passportNumberHint: 'AD2098993',
    savedOk: 'Сохранено',
    applications: 'Визовые анкеты',
    addApplication: 'Анкета',
    noApplications: 'Анкеты не добавлены',
    applicationNumber: 'Номер анкеты',
    applicationDate: 'Дата',
    applicationCountry: 'Страна',
    applicationVisaType: 'Тип визы',
    applicationStatus: 'Статус',
    applicationNumberPrompt: 'Введите номер анкеты',
    applicationNumberRequired: 'Номер не может быть пустым',
    appStatusSubmitted: 'Подана',
    appStatusWaiting: 'Ожидание',
    appStatusAccepted: 'Одобрена',
    appStatusRejected: 'Отказ',
    deleteApplicationConfirm: 'Анкета {number} будет удалена. Продолжить?',
    title: 'Информация о клиенте',
    downloadAll: 'Скачать всё',
    firstName: 'Имя',
    lastName: 'Фамилия',
    dateOfBirth: 'Дата рождения',
    passportNumber: 'Номер паспорта',
    nationality: 'Гражданство',
    issueDate: 'Дата выдачи',
    expiryDate: 'Срок действия',
    issuedBy: 'Кем выдан',
    issuedByHint: 'Например: MIA 26001 / IIV 26001',
    anketaData: {
      employerTitle: 'Текущее место работы (в стране проживания) — анкета 6/13',
      viewAll: 'Все',
      formHint: 'Все данные, которые спрашивает анкета, по страницам. Красное — не хватает: заполните здесь, и анкетный агент не будет спрашивать во время работы.',
      progress: 'Обязательные данные: готово {tayyor} / {jami}',
      notNeeded: 'не требуется',
      title: 'Данные анкеты',
      hint: 'Данные, собранные для визовой анкеты (работодатель, адрес, поездка). Нажмите на значение, чтобы исправить — анкета в следующий раз возьмёт его.',
      refresh: 'Обновить',
      loadError: 'Данные анкеты не загрузились — редактирование закрыто',
      conflict: 'Значение изменилось — обновите страницу и подтвердите снова',
    },
    country: 'Страна',
    travelPurpose: 'Цель поездки',
    direction: 'Направление',
    status: 'Статус',
    jobTitle: 'На какую работу',
    employerName: 'Работодатель',
    phone: 'Телефон',
    address: 'Адрес',
    notes: 'Примечания',
    registeredBy: 'Зарегистрировал',
    updatedAt: 'Дата обновления',
    createdAt: 'Дата создания',
    createCv: 'Создать CV',
    lastModifiedBy: 'Последнее изменение',
    passportImage: 'Фото паспорта',
    universityName: 'Название ВУЗа',
    studyProgram: 'Программа обучения',
    travelDates: 'Даты поездки',
    hotelName: 'Название отеля',
    destinationCountry: 'Страна назначения',
    personalInfo: 'Личные данные',
    directionInfo: 'Данные по направлению',
    passportInfo: 'Паспортные данные',
    passportOptional: 'Паспортные данные (необязательно)',
    statusChanged: 'Статус изменён',
    statusChangeError: 'Ошибка изменения статуса',
    workDirection: 'Работа',
    studyDirection: 'Учёба',
    travelDirection: 'Путешествие',
    businessDirection: 'Бизнес',
    fullView: 'Подробнее',
    updateSuccess: 'Данные клиента обновлены',
    updateError: 'Ошибка обновления данных',
    notFound: 'Клиент не найден',
    loadError: 'Клиент не найден или ошибка загрузки',
    noId: 'ID клиента не найден',
    documents: 'Документы',
    selectDocType: 'Выберите тип документа',
    selectFile: 'Выберите файл',
    uploadHint: 'Допустимые форматы: PDF, JPG, PNG, GIF, DOC, DOCX, XLS, XLSX, PPT, PPTX, MP4, AVI, MOV (макс 100МБ)',
    uploadSuccess: 'Документ успешно загружен!',
    uploadError: 'Ошибка загрузки документа',
    noDocuments: 'Нет документов',
    confirmDeleteDoc: 'Документ попадёт в корзину — файл и распознанные данные сохранятся, его можно вернуть из «Корзины». Причина (необязательно):',
    docDeleteSuccess: 'Документ в корзине — его можно вернуть',
    deleteDocSabab: 'Например: загружен по ошибке, старая версия',
    savatgaTashlash: 'В корзину',
    docDeleteError: 'Ошибка удаления документа',
    downloadError: 'Ошибка скачивания',
    fileSizeError: 'Размер файла не должен превышать 100МБ',
    additionalNotes: 'Дополнительные примечания',
    showMore: 'Показать ещё',
    showLess: 'Свернуть',
    moreFiles: 'файлов',
    prevDoc: 'Предыдущий',
    nextDoc: 'Следующий',
    previewNotAvailable: 'Предпросмотр для этого типа файла недоступен. Скачайте файл.',
    videoNotSupported: 'Ваш браузер не поддерживает этот формат видео',
    docs: {
      addMore: '+ Загрузить ещё',
      filesSelected: 'Выбрано файлов: {n}',
      nUploaded: 'Загружено файлов: {n}',
      badFile: '{fayl}: такой тип файла не принимается',
      tooLarge: '{fayl}: больше {mb} МБ',
      multiHint: 'Можно выбрать или перетащить сразу несколько файлов. PDF, JPG, PNG, DOC(X), XLS(X), PPT(X) — до 50 МБ. Видео (до 300 МБ) само попадает в раздел «Видеоролик»',
      variantName: 'Вариант CV',
      variantPrompt: '{fayl} — как назвать этот вариант CV? (например: должность и язык)',
      variantPlaceholder: 'например: Сварщик — английский',
      turniTasdiqla: 'Подтвердить тип: {tur}',
      turTasdiqlangan: 'Тип подтверждён',
      topshiriladi: 'Подаётся',
      topshirilmaydi: 'Не подаётся',
      topshirishYoq: 'Без отметки',
      topshirishBelgila: 'Подавать?',
      topshirishOlib: 'Снять отметку',
      topshirishHint: 'Подаётся ли в посольство — нажмите, чтобы отметить',
      topshirishKim: 'Отметил(а): {kim}, {vaqt}',
      topshirishFiltrHint: 'Документы, которые войдут в папку для посольства',
      topshirilmaydiSabab: 'Почему не подаётся? (необязательно)',
      topshirilmaydiMisol: 'например: только для сведения',
      izohUzun: 'Не более 300 символов',
      turTasdiqKim: 'Подтвердил: {kim}, {vaqt}. Нажмите, чтобы снять подтверждение',
      turTasdiqlandi: 'Тип документа подтверждён — анкета теперь опирается на него',
      turTasdiqOlindi: 'Подтверждение типа снято',
      nomTitle: 'Название документа',
      nomPrompt: '{fayl} — что это за документ? Укажите название: файл сохранится под этим именем.',
      nomPromptQayta: 'Укажите название документа: файл будет переименован.',
      nomPlaceholder: 'например: Военный билет',
      nomBosh: 'Укажите название документа',
      nomUzun: 'Название — не длиннее 200 символов',
      nomBer: 'Дать название',
      nomOzgartir: 'Переименовать',
      nomSaqlandi: 'Название сохранено',
      faqatVideo: '{fayl}: в раздел «Видеоролик» загружаются только видеофайлы (mp4, mov ...)',
      videogaOtdi: 'Видео ({n}) загружено в раздел «Видеоролик»',
      videoOqilmaydi: 'Видео — не распознаётся',
      filterAll: 'Все',
      filterDone: 'Прочитаны',
      filterQueue: 'В очереди',
      filterAttention: 'Требуют внимания',
      queueHint: 'Документы в очереди или читаются сейчас',
      attentionHint: 'Не прочитаны, чужие / владелец не определён или прочитаны не полностью',
      searchPlaceholder: 'Поиск по имени файла или типу',
      dropTitle: 'Перетащите файл сюда',
      dropOr: 'или',
      dropBrowse: 'выберите на компьютере',
      dropActive: 'Отпустите файл',
      typeRequired: 'Чтобы загрузить, выберите тип документа',
      colDocument: 'Документ',
      colStatus: 'Статус чтения',
      colUploaded: 'Загружен',
      noMatch: 'Нет документов по этому фильтру',
      resetFilter: 'Сбросить фильтр',
      showMoreN: 'Показать ещё {n}',
    },
    // Статус чтения документа (OASIS / CEO PC)
    aylantir: {
      chapga: 'Повернуть влево',
      ongga: 'Повернуть вправо',
      asl: 'Исходный вид',
      aslHint: 'Вернуть документ в исходное положение (оригинал сохранён)',
      saqlanmoqda: 'Сохранение…',
      ok: 'Документ повёрнут',
      okAsl: 'Документ возвращён в исходное положение',
      okQayta: 'Документ повёрнут и отправлен на повторное чтение',
      xato: 'Не удалось повернуть',
    },
    extraction: {
      orqaTomon: 'Оборот?',
      orqaTomonHint: 'Похоже, не загружена оборотная сторона ID-карты: ПИНФЛ и место рождения указаны там. Загрузите и оборот («+ Ещё»).',
      mijozHozir: 'Читать сейчас',
      mijozHozirHint: 'Этот клиент важнее всех: его документы — в начало очереди. Непрочитанные и неполные будут прочитаны заново',
      mijozHozirOk: '{u} док. в начало очереди, {q} отправлено на повторное чтение',
      mijozHozirNavbatda: 'Документы уже в начале очереди ({n})',
      mijozHozirToliq: 'Все документы прочитаны, нужные данные получены',
      agentShu: 'Агент сейчас читает документы этого клиента',
      agentBoshqa: 'Агент читает другого клиента — затем сразу перейдёт к этому',
      agentTayyor: 'Агент готов — начнёт через несколько секунд',
      agentUzilgan: 'Агент не на связи {m} мин — проверьте, включён ли компьютер агента и интернет',
      agentYoq: 'Агент не подключён — проверьте, включён ли компьютер агента',
      oqish: 'Читать документ агентом',
      oqishYorliq: 'Чтение',
      oqishOn: 'Агент прочитает документ. Если выключить — уйдёт из очереди (прочитанные данные сохранятся)',
      oqishOnForced: 'Включено сотрудником: этот тип обычно не читается, но будет прочитан',
      oqishOff: 'Не читается — выключено сотрудником. Включите, чтобы поставить в очередь',
      oqishOffAuto: 'Этот тип обычно не читается (достаточно наличия). Включите, чтобы прочитать',
      oqishYoqildi: 'Чтение включено',
      oqishOchirildi: 'Чтение выключено — документ убран из очереди',
      hozir: 'Прочитать сейчас',
      hozirHint: 'В начало очереди — агент прочитает его первым в следующем цикле',
      hozirOk: 'Поставлено в начало очереди',
      orin: '{n}-е место',
      // Запись факта в поле клиента
      applyToField: 'Записать в поле клиента',
      appliedTo: 'Записано в поле {field}',
      notApplied: 'Не записано',
      ownerFamily: 'Член семьи #{n}',
      ownerFamilyPlain: 'Член семьи',
      ownerForeign: 'Посторонний',
      ownerUnknown: 'Владелец неизвестен',
      summary: 'Прочитано {done}/{total}',
      summaryHint: 'Сколько документов OASIS (CEO PC) прочитал и добавил в базу',
      doneCount: 'Прочитан · фактов: {n}',
      pending: 'В очереди',
      processing: 'Читается',
      failed: 'Ошибка',
      skipped: 'Не читается',
      opusKutadi: 'Ожидает проверки Opus',
      opusKutadiHint: 'Рукописный документ: правилами (OCR / MRZ) не читается — его читает проверяющий Opus с цитатами',
      opusOdam: 'Opus не смог прочитать — нужен человек',
      opusIshYoq: 'Opus прочитал — записей о работе нет',
      unknown: 'Нет статуса',
      pendingHint: 'Ещё не прочитан — в очереди CEO PC',
      processingHint: 'CEO PC сейчас читает документ',
      failedHint: 'Не удалось прочитать: {error}',
      skippedHint: 'Из документов этого типа данные не извлекаются',
      skippedReasonHint: 'Не прочитан: {error}',
      unknownHint: 'Статус чтения не записан',
      factsTitle: 'Данные, извлечённые из документа',
      doneOf: 'Прочитан · {olindi}/{jami}',
      expectedTitle: 'Ожидаемые данные',
      notExtracted: 'Не извлечено',
      humanReads: 'Сотрудник вносит из документа',
      presenceOnly: 'Данные из этого документа не читаются — достаточно его наличия в базе',
      openFactsHint: 'Нажмите — документ и извлечённые из него данные откроются рядом',
      noFacts: 'Данные в документе не найдены',
      notReadYet: 'Документ ещё не прочитан',
      verified: 'Подтверждено (MRZ / контрольная цифра)',
      unverified: 'Не подтверждено — проверьте',
      loadError: 'Не удалось загрузить данные',
      reprocess: 'Отправить на повторную проверку',
      reprocessShort: 'Перепроверить',
      autoApplied: 'Автоматически записано в карточку: {fields}',
      reprocessConfirm: 'Документ будет проверен заново, текущие извлечённые данные удалятся. Укажите причину (необязательно):',
      reprocessQueued: 'Документ поставлен в очередь на повторное чтение',
      reprocessError: 'Не удалось поставить в очередь',
      reprocessPrompt: 'Документ будет проверен заново. Укажите причину (необязательно):',
      reprocessReasonPlaceholder: 'Например: неверная фамилия',
      reviewInfo: 'Отправил(а) на проверку: {user}, {date}',
      foreignSummary: 'Чужих документов: {n}',
      foreignSummaryHint: 'Эти документы, похоже, принадлежат другому человеку — проверьте, не загружены ли они по ошибке',
      docOwnerForeign: 'Чужой документ',
      docOwnerUnknown: 'Владелец не определён',
      docOwnerFamily: 'Документ члена семьи',
    },

    firstNameRequired: 'Введите имя',
    lastNameRequired: 'Введите фамилию',
    passportRequired: 'Введите номер паспорта',
    birthDateRequired: 'Выберите дату рождения',
    issueDateRequired: 'Выберите дату выдачи',
    expiryDateRequired: 'Выберите срок действия',
    countryRequired: 'Введите страну',
    phoneRequired: 'Введите номер телефона',
    addressRequired: 'Введите адрес',
    vacLinkedSuccess: 'Вакансий привязано: {count}',
    vacUnlinkedSuccess: 'Вакансия откреплена',
    employeesAssigned: 'Сотрудники закреплены',
    employeeAssigned: 'Сотрудник закреплён',
    assignCancelled: 'Закрепление отменено',
    fileTooLarge: 'Размер файла не должен превышать 100 МБ',
    errorGeneric: 'Произошла ошибка',
  },

  docTypes: {
    oddiy_pasport: 'Паспорт (внутренний)',
    zagran_pasport: 'Загранпаспорт',
    bank_schyot: 'Выписка из банка',
    ish_staji: 'С места работы',
    ishxona_tarjima: 'С места работы (перевод)',
    mygov_digital: 'Digital information (my.gov)',
    mygov_family: 'Family information (my.gov)',
    mygov_yashash: 'Справка с места жительства (my.gov)',
    anketa: 'Анкета',
    explanation_letter: 'Explanation letter',
    hotel_booking: 'Бронь отеля',
    bron_bilet: 'Бронь авиабилета',
    priglosheniye: 'Приглашение',
    diplom: 'Диплом',
    til_sertifikat: 'Языковой сертификат',
    trip_plan: 'План поездки',
    sudlanmaganlik: 'Справка о несудимости',
    sudlanmaganlik_tarjima: 'Справка о несудимости (перевод)',
    mol_mulk: 'Имущество',
    mol_mulk_tarjima: 'Имущество (перевод)',
    sugurta: 'Страховка',
    cv_photo: 'Фото',
    cv: 'CV',
    qoshimcha: 'Дополнительные документы',
    video: 'Видеоролик',
    patent: 'Рабочий патент (Россия)',
    nikoh_guvohnoma: 'Свидетельство о браке',
  },

  clientCreate: {
    title: 'Создать нового клиента',
    step1Title: 'Паспорт и основные данные',
    whichRegion: 'В какой регион',
    whichCountry: 'В какую страну',
    selectCountryOptional: 'Выберите страну (необязательно)',
    peopleCount: 'Количество человек',
    uploadPassportText: 'Загрузите фото паспорта <em>или перетащите сюда</em>',
    uploadPassportTip: 'JPG/PNG формат. OCR автоматически распознает данные.',
    dividerBasic: 'Основные данные',
    dividerPassport: 'Паспортные данные',
    regionEurope: 'Европа',
    regionAsia: 'Азия',
    regionAmerica: 'Америка',
    regionOther: 'Другое',
    person1: '1 человек',
    person2: '2 человека',
    personFamily: 'Семья',
    personGroup: 'Группа',
    personOther: 'Другое',
    step2Title: 'Выбор направления',
    step3Title: 'Паспорт (необязательно)',
    step1: 'Загрузка паспорта',
    step2: 'Редактирование данных',
    step3: 'Дополнительная информация',
    step4: 'Загрузка документов',
    firstName: 'Имя',
    lastName: 'Фамилия',
    directionSelect: 'Выберите направление',
    saveWithoutPassport: 'Сохранить без паспорта',
    universityName: 'Название ВУЗа',
    studyProgram: 'Программа обучения',
    travelDates: 'Даты поездки',
    hotelName: 'Название отеля',
    passportUploadDrag: 'Перетащите фото паспорта сюда или',
    passportUploadClick: 'нажмите',
    passportUploadHint: 'Формат JPG, JPEG или PNG, макс 10МБ',
    processOcr: 'Обработать (OCR)',
    ocrProcessing: 'Обработка OCR...',
    ocrDialogTitle: 'Результат OCR',
    ocrExtractedData: 'Извлечённые данные',
    ocrRawText: 'Исходный текст',
    ocrNoText: 'Текст не найден',
    ocrClose: 'Закрыть',
    ocrContinue: 'Продолжить',
    ocrSuccess: 'Паспорт успешно обработан',
    ocrError: 'Ошибка обработки OCR',
    ocrNotFound: 'Данные паспорта не найдены',
    ocrParseError: 'Ошибка анализа данных',
    destinationCountry: 'Страна назначения',
    travelPurpose: 'Цель поездки',
    jobTitle: 'На какую работу',
    employerName: 'Название работодателя',
    phone: 'Телефон',
    address: 'Адрес',
    additionalNotes: 'Дополнительные примечания',
    clientCreatedSuccess: 'Клиент успешно создан!',
    uploadDocuments: 'Загрузите документы',
    done: 'Завершить',
    createError: 'Ошибка создания клиента',
    firstNameRequired: 'Введите имя',
    lastNameRequired: 'Введите фамилию',
    passportRequired: 'Введите номер паспорта',
    birthDateRequired: 'Выберите дату рождения',
    issueDateRequired: 'Выберите дату выдачи',
    expiryDateRequired: 'Выберите срок действия',
    countryRequired: 'Введите страну',
    phoneRequired: 'Введите номер телефона',
    addressRequired: 'Введите адрес',
    placeholderFirstName: 'Например: SHERZOD',
    placeholderLastName: 'Например: XOTAMOV',
    placeholderAddress: 'Город, район',
    placeholderNotes: 'Дополнительные заметки...',
    placeholderCountry: 'Например: Германия',
    placeholderJobTitle: 'Например: Строитель',
    placeholderEmployer: 'Название компании',
    placeholderUniversity: 'Название университета',
    placeholderProgram: 'Например: IT, Медицина',
    placeholderTravelDates: 'Например: 15.06 - 30.06',
    placeholderHotel: 'Название отеля',
    placeholderPassportNumber: 'Например: AD2098993',
    placeholderPosition: 'Должность или цель',
    dividerWorkInfo: 'Информация о работе',
    dividerStudyInfo: 'Информация об учёбе',
    dividerTravelInfo: 'Информация о поездке',
    dividerBusinessInfo: 'Информация о бизнесе',
    passportOptionalNote: 'Можно создать клиента без паспорта',
    ocrResultsTitle: 'Результаты OCR',
    detectedData: 'Обнаруженные данные',
    verifyImage: 'Сверьте с изображением',
    clickToEnlarge: 'Нажмите для увеличения',
    applyOcr: 'Применить и заполнить',
    editIfWrong: '✎ Отредактируйте, если неверно',
    manualSection: 'Вводится вручную',
    manualSectionSub: 'Эти поля OCR не определяет — сотрудник заполняет сам',
    duplicateTitle: 'Клиент уже существует',
    duplicateMsg: 'Клиент с таким номером паспорта ({name}) уже зарегистрирован. Открыть?',
    openExisting: 'Открыть',
    alreadyExistsShort: 'Клиент с таким номером паспорта уже существует',
  },

  vacancies: {
    title: 'Вакансии',
    totalVacancies: 'Всего вакансий',
    active: 'Активные',
    closed: 'Закрытые',
    draft: 'Черновики',
    searchPlaceholder: 'Вакансия, компания, город...',
    jobType: 'Тип работы',
    experience: 'Опыт',
    statusFilter: 'Статус',
    newVacancy: 'Новая вакансия',
    editVacancy: 'Редактировать вакансию',
    vacancyName: 'Название вакансии',
    company: 'Компания',
    city: 'Город',
    country: 'Страна',
    description: 'Описание',
    salaryMin: 'Зарплата (мин)',
    salaryMax: 'Зарплата (макс)',
    currency: 'Валюта',
    status: 'Статус',
    deadline: 'Срок',
    deadlineLabel: 'Крайний срок',
    fullTime: 'Полная занятость',
    partTime: 'Частичная занятость',
    contract: 'Контракт',
    temporary: 'Временная',
    noExperience: 'Без опыта',
    junior: 'Младший (0-2 года)',
    mid: 'Средний (2-5 лет)',
    senior: 'Старший (5+ лет)',
    draftStatus: 'Черновик',
    activeStatus: 'Активный',
    closedStatus: 'Закрытый',
    uzs: "Сум (UZS)",
    usd: 'Доллар (USD)',
    eur: 'Евро (EUR)',
    rub: 'Рубль (RUB)',
    confirmDelete: 'Вы хотите удалить эту вакансию?',
    deleteSuccess: 'Вакансия удалена',
    updateSuccess: 'Вакансия обновлена',
    createSuccess: 'Вакансия создана',
    formError: 'Произошла ошибка',
    notFound: 'Вакансии не найдены',
    nameRequired: 'Введите название вакансии',
    companyRequired: 'Введите название компании',
    cityRequired: 'Введите город',
    countryRequired: 'Введите страну',
    descriptionRequired: 'Введите описание',
    descriptionPlaceholder: 'Подробное описание вакансии...',
  },

  scraped: {
    copyPhone: 'Скопировать номер',
    phoneCopied: 'Скопировано: {phone}',
    copyFailed: 'Не удалось скопировать',
    bulkDeleteBtn: 'Удалить',
    title: 'Скрапленные вакансии',
    total: 'Всего',
    unchecked: 'Непроверенные',
    agency: 'Агентство',
    direct: 'Напрямую',
    scammer: 'Мошенник',
    allFilter: 'Все',
    calledFilter: 'С звонком',
    categoryFilter: 'Категория',
    noAnswer: 'Не взял трубку',
    callback: 'Просил перезвонить',
    callError: 'Ошибка обновления статуса',
    countryFilter: 'Страна',
    siteFilter: 'Сайт',
    scrapeBtn: '1. Скрапинг',
    filterBtn: '2. Фильтр',
    detailBtn: '3. Детали',
    uploadBtn: '4. Загрузка',
    importJson: 'Импорт JSON',
    clearBtn: 'Очистить',
    jobTitle: 'Название',
    postedDate: 'Дата',
    country: 'Страна',
    direction: 'Направление',
    phoneNumber: 'Телефон',
    email: 'Email',
    phoneCall: 'Звонок',
    category: 'Категория',
    unassigned: 'Не назначен',
    remoteTag: 'Удалённо',
    expiredTag: 'Устарело',
    partnerNew: 'Партнёр',
    partnerRegular: 'Постоянный',
    partnerPremium: 'VIP',
    ctAgency: 'Агентство',
    ctDirect: 'Напрямую',
    ctScammer: 'Мошенник',
    ctUnknown: 'Неизвестно',
    ctOpen: 'Открыто',
    dirWork: 'Работа',
    dirStudy: 'Учёба',
    dirTravel: 'Путешествие',
    dirAvia: 'Авиа',
    subWarehouse: 'Склад',
    subFactory: 'Производство',
    subFarm: 'Ферма',
    subBuild: 'Стройка',
    subIt: 'IT',
    subOther: 'Общее',
    expired: 'Устарело',
    selectEmployees: 'Выберите сотрудников',
    removeAssignees: 'Снять сотрудников',
    assignBtn: 'Назначить',
    makeOpen: 'Сделать открытым',
    viewOnlyBanner: 'Эта вакансия назначена {name}. Режим просмотра.',
    contactLabel: 'Контакт',
    phoneLabel: 'Телефон',
    phonesLabel: 'Телефоны',
    emailLabel: 'Email',
    emailsLabel: 'Email-ы',
    telegramLabel: 'Telegram',
    whatsappLabel: 'WhatsApp',
    openSource: 'Открыть оригинал',
    newVacanciesAlert: '{n} новых вакансий от этой компании!',
    otherVacancies: 'Другие вакансии этого контакта ({n})',
    newTag: 'НОВЫЙ',
    callsCount: '{n} звонков',
    callBtn: 'Звонок',
    emailBtn: 'Email',
    callAnswered: 'Ответил',
    callNoAnswer: 'Не ответил',
    callCallback: 'Перезвонить',
    writeNotePh: 'Напишите заметку...',
    selectCategory: 'Выберите категорию',
    saveBtn: 'Сохранить',
    filterAll2: 'Все',
    filterCallback: 'Перезвонить',
    searchByNotePh: 'Поиск по заметкам...',
    noNoteWritten: 'Заметка не написана',
    noCallsYet: 'Звонков пока нет',
    callsTab: 'Звонки',
    linkedClientsTab: 'Назначенные клиенты',
    addClientBtn: '+ Добавить клиента',
    noLinkedClients: 'Назначенных клиентов нет',
    unlinkClient: 'Удалить',
    selectClientDialog: 'Выбор клиента',
    clientSearchPh: 'Имя, телефон, паспорт...',
    refreshTip: 'Обновить',
    totalClients: 'Всего: {n} · Показано: {m}',
    notFoundShort: 'Не найдено',
    noClientsYet: 'Клиентов нет',
    selectedSuffix: 'выбрано: {n}',
    cancelBtn: 'Отмена',
    linkBtn: 'Назначить',
    ctDirect2: 'Работодатель',
    ctAgency2: 'Агентство',
    ctScammer2: 'Мошенник',
    ctUnknown2: 'Неизвестно',
    qnAnswered1: 'Поговорил, дал информацию',
    qnAnswered2: 'Готовит документы',
    qnAnswered3: 'Договорились, ждёт',
    qnAnswered4: 'Обсудили контракт',
    qnAnswered5: 'Запросил документы',
    qnAnswered6: 'Договорились на другое время',
    qnNoAns1: 'Не взял, не ответил',
    qnNoAns2: 'Номер устарел / не работает',
    qnNoAns3: 'Номер принадлежит другому',
    qnNoAns4: 'Телефон выключен',
    qnNoAns5: 'Отказался от звонка',
    qnNoAns6: 'Вне сети',
    qnCall1: 'Попросил перезвонить позже',
    qnCall2: 'Занят, попросил перезвонить',
    qnCall3: 'Сейчас не может говорить',
    qnCall4: 'На другой линии',
    qnCall5: 'Перезвонить в рабочее время',
    qnCall6: 'Работает с другим агентством',
    notFound: 'Вакансии не найдены',
    process: 'Процесс',
    running: 'Выполняется...',
    finished: 'Завершено!',
    now: 'Сейчас',
    stop: 'Остановить',
    scrapeLabel: 'Скрапинг (9 сайтов)',
    filterLabel: 'Фильтр (по ключевым словам)',
    detailLabel: 'Детали (получить телефон/email)',
    anotherRunning: 'Другой процесс уже выполняется',
    scrapeError: 'Скрапинг не запустился',
    filterError: 'Фильтр не запустился',
    detailError: 'Детали не запустились',
    importSuccess: 'Импорт: {created} новых, {skipped} дубликатов',
    importError: 'Ошибка импорта',
    clearConfirm: 'Все невызванные вакансии будут удалены. Вызванные сохранятся.',
    clearTitle: 'Очистка базы',
    stopRequested: 'Запрос на остановку отправлен — процесс скоро завершится',
    stopError: 'Ошибка остановки',
    saveError: 'Ошибка сохранения',
    classifyError: 'Произошла ошибка',
    callError: 'Произошла ошибка',
    phonePlaceholder: '+371...',
    emailPlaceholder: 'email@...',
    filterAll: 'Все',
    filterCalled: 'С звонком',
    filterAssigned: 'Закреплены',
    filterRecall: 'Перезвонить',
    directionPlaceholder: 'Направление',
    jobTypePlaceholder: 'Тип работы',
    detailsLoadError: 'Не удалось загрузить детали',
    errorGeneric: 'Произошла ошибка',
    vacancyReopened: 'Вакансия открыта',
    noteSaved: 'Заметка сохранена',
    noteError: 'Ошибка сохранения заметки',
    callLogError: 'Ошибка записи звонка',
    partnerAlready: 'Эта вакансия уже в списке партнёров',
    saved: 'Сохранено',
    clientUnlinked: 'Клиент откреплён',
    markedAsPartner: 'Отмечено как партнёр',
    selectTime: 'Выберите время',
    scheduleAdded: 'Расписание добавлено',
    deleted: 'Удалено',
  },

  users: {
    title: 'Сотрудники',
    newEmployee: 'Новый сотрудник',
    username: 'Логин',
    fullName: 'ФИО',
    email: 'Email',
    phone: 'Телефон',
    role: 'Роль',
    status: 'Статус',
    actions: 'Действия',
    editTitle: 'Редактировать сотрудника',
    createTitle: 'Новый сотрудник',
    firstName: 'Имя',
    lastName: 'Фамилия',
    password: 'Пароль',
    roleAdmin: 'Руководитель',
    roleEmployee: 'Сотрудник',
    activeStatus: 'Активный',
    inactiveStatus: 'Неактивный',
    editSuccess: 'Сотрудник обновлён',
    createSuccess: 'Сотрудник создан',
    saveError: 'Ошибка сохранения',
    loadError: 'Ошибка загрузки данных',
    usernameRequired: 'Введите логин',
    emailRequired: 'Введите email',
    firstNameRequired: 'Введите имя',
    lastNameRequired: 'Введите фамилию',
    passwordRequired: 'Введите пароль',
    passwordMinLength: 'Минимум 6 символов',
    resetPassword: 'Сбросить пароль',
    resetPasswordTitle: 'Сброс пароля',
    resetPasswordHint: 'Установите новый пароль (старый пароль не требуется)',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    newPasswordPlaceholder: 'Введите новый пароль',
    confirmPasswordPlaceholder: 'Повторите пароль',
    newPasswordRequired: 'Введите новый пароль',
    confirmPasswordRequired: 'Подтвердите пароль',
    passwordsNotMatch: 'Пароли не совпадают',
    resetPasswordSuccess: 'Пароль успешно сброшен!',
    resetPasswordError: 'Ошибка сброса пароля',
  },

  profile: {
    title: 'Профиль',
    username: 'Логин',
    email: 'Email',
    firstName: 'Имя',
    lastName: 'Фамилия',
    phone: 'Телефон',
    role: 'Роль',
    roleAdmin: 'Руководитель',
    roleEmployee: 'Сотрудник',
    changePassword: 'Изменить пароль',
    changePasswordTitle: 'Изменить пароль',
    oldPassword: 'Старый пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Подтвердите пароль',
    passwordsNotMatch: 'Пароли не совпадают',
    oldPasswordRequired: 'Введите старый пароль',
    newPasswordRequired: 'Введите новый пароль',
    newPasswordMinLength: 'Минимум 6 символов',
    confirmPasswordRequired: 'Подтвердите пароль',
    passwordChanged: 'Пароль успешно изменён',
    adminResetHint: 'Как админ, вы можете изменить пароль без старого',
    passwordChangeError: 'Ошибка изменения пароля',
    uploadAvatar: 'Загрузить фото',
    uploadAvatarSuccess: 'Фото успешно загружено',
    uploadAvatarError: 'Ошибка загрузки фото',
    avatarSizeError: 'Размер фото не должен превышать 20МБ',
    editProfile: 'Редактировать профиль',
    saveProfile: 'Сохранить',
    editSuccess: 'Данные сохранены',
    editError: 'Ошибка сохранения',
  },

  settings: {
    title: 'Настройки',
    basePath: 'Путь хранения файлов',
    basePathPlaceholder: 'Например: /home/user/crm_files',
    save: 'Сохранить',
    hint: 'Документы клиентов будут сохранены по этому пути. Если пусто, используется MEDIA_ROOT.',
    currentStructure: 'Текущая структура',
    noSetting: 'Настройка не задана (по умолчанию MEDIA_ROOT)',
    pathRequired: 'Введите путь',
    saveSuccess: 'Настройка сохранена',
    saveError: 'Ошибка сохранения',
  },

  cvBuilder: {
    title: 'CV Builder',
    back: 'Назад',
    cvBuild: 'CV Build',
    jobDetails: 'Детали вакансии',
    layoutSubtitle: 'Выберите структуру расположения CV',
    layout: 'Структура',
    templateSubtitle: 'Выберите цветовую схему CV',
    template: 'Цветовая схема',
    jobDetailPlaceholder: 'Вставьте описание вакансии: должность, компания, страна, требования...',
    selectClient: 'Выберите клиента',
    searchClient: 'Поиск клиента...',
    clientSearchResults: 'Найдено {count} результатов',
    clientPageInfo: '{from}–{to} из {total}',
    fullName: 'ФИО',
    passport: 'Паспорт',
    country: 'Страна',
    phone: 'Телефон',
    selectedClient: 'Выбранный клиент',
    buildCv: 'Создать CV',
    description: 'Описание',
    sourceLink: 'Ссылка на источник',
    noJob: 'Вакансия не найдена',
    buildSuccess: 'CV успешно создан!',
    buildError: 'Ошибка создания CV',
    loadError: 'Ошибка загрузки данных',
    jobTitle: 'Название должности',
    company: 'Компания',
    city: 'Город',
    salary: 'Зарплата',
    language: 'Язык CV',
    jobTitlePlaceholder: 'Напр.: Повар, Строитель...',
    companyPlaceholder: 'Название компании',
    countryPlaceholder: 'Напр.: Германия',
    cityPlaceholder: 'Напр.: Берлин',
    salaryPlaceholder: 'Напр.: 1500 EUR',
    descriptionPlaceholder: 'Описание вакансии...',
    previewHint: 'Нажмите на текст для редактирования. Нажмите на фото — появится панель зума и перемещения. Все изменения сохранятся в PDF.',
    saveAsPdf: 'Как PDF',
    saveAsDocx: 'Как Word (DOCX)',
    saveFormatTitle: 'В каком формате сохранить?',
    saveFormatPdfDesc: 'Сохранит ваши изменения, профессиональный вид',
    saveFormatDocxDesc: 'Оригинальный Word без изменений',
    recommended: 'Рекомендуем',
    previewTitle: 'Предпросмотр CV',
    save: 'Сохранить',
    discard: 'Отменить',
    discarded: 'CV отменён',
    prompts: 'Промпты',
    newPrompt: 'Новый промпт',
    editPrompt: 'Редактировать промпт',
    promptName: 'Название промпта',
    promptNamePlaceholder: 'Напр.: Стандартный промпт для CV',
    promptContent: 'Текст промпта',
    promptChars: '{count} символов',
    promptContentPlaceholder: 'Напишите инструкции для генерации CV...',
    noPrompts: 'Промпты ещё не добавлены',
    promptRequired: 'Необходимо заполнить название и текст',
    promptCreated: 'Промпт создан',
    promptUpdated: 'Промпт обновлён',
    promptDeleted: 'Промпт удалён',
    promptSaveError: 'Ошибка сохранения промпта',
    promptDeleteError: 'Ошибка удаления промпта',
    photoTitle: 'Фото для CV',
    uploadPhoto: 'Загрузить фото',
    photoUploaded: 'Фото загружено (для этого CV)',
    photoFromClient: 'Используется фото из профиля клиента',
    photoNone: 'Фото отсутствует',
    photoInvalid: 'Поддерживаются только изображения',
    photoWarnForLayout: 'Выбранный шаблон рассчитан на фото. Загрузите фото для лучшего результата.',
    reviewTitle: 'Проверьте данные CV и подтвердите',
    reviewHint: 'Внимательно проверьте данные, созданные AI. Исправьте при необходимости. После подтверждения будет создан PDF.',
    professionalTitle: 'Профессиональное название должности',
    summary: 'Профессиональное резюме',
    experience: 'Опыт работы',
    position: 'Должность',
    employer: 'Работодатель (компания)',
    period: 'Период',
    periodPlaceholder: 'Например: Сентябрь 2018 – Июнь 2021',
    description: 'Описание',
    institution: 'Учебное заведение',
    specialization: 'Специальность / Степень',
    addExp: 'Добавить опыт',
    addEdu: 'Добавить образование',
    addSkill: 'Добавить навык',
    addLanguage: 'Добавить язык',
    confirmAndGeneratePdf: 'Подтвердить и создать PDF',
    note: 'Примечание',
    education: 'Образование',
    skills: 'Навыки',
    languages: 'Языки',
    enhanceWithAI: 'Улучшить с AI',
    photoEnhanced: 'Фото улучшено AI',
    clearVacancy: 'Очистить',
    vacancySearchPlaceholder: 'Поиск вакансии (название, страна, компания)...',
    layoutModernPhoto: 'Современный',
    layoutBadgeSidebar: 'Элегантная панель',
    layoutTopHeader: 'Верхняя панель',
    layoutSidebarLeft: 'Левая панель',
    layoutSidebarRight: 'Правая панель',
    layoutClassic: 'Классический',
    imgZoomOut: 'Уменьшить',
    imgZoomIn: 'Увеличить',
    imgPanLeft: 'Влево',
    imgPanUp: 'Вверх',
    imgPanDown: 'Вниз',
    imgPanRight: 'Вправо',
    imgReset: 'Сбросить',
    imgClose: 'Закрыть',
    aiFallbackWithError: 'AI не сработал, использован запасной режим: {error}',
    aiFallbackPlain: 'AI не сработал, создан обычный CV',
    buildTimeout: 'Превышено время ожидания при создании CV (timeout). Пожалуйста, попробуйте ещё раз.',
    docxEditsLostWarning: 'Файл Word сохранится в оригинальном виде, без ваших изменений. Чтобы сохранить изменения, выберите PDF.',
    clientAutoSelected: 'Клиент выбран автоматически: {name}',
    clientLoadFailed: 'Не удалось загрузить клиента — выберите вручную',
  },

  telefonlar: {
    qoshish: '+ Добавить номер',
    tahrirlash: 'Изменить',
    raqam_qoshish: 'Добавить номер',
    raqam: 'Номер',
    namuna: '+998 90 123 45 67',
    olib_tashlash: 'Удалить',
    maks: 'Не более {n} дополнительных номеров',
    nusxa: 'Копировать',
    nusxalandi: 'Скопировано',
  },
  educationEditor: {
    kiritilmagan: 'Образование не указано',
    qoshish: '+ Добавить образование',
    tahrirlash: 'Изменить',
    label: 'Образование',
    institutionLabel: 'Учебное заведение',
    institutionPlaceholder: 'Например: Ташкентский Государственный Технический Университет',
    specializationLabel: 'Специальность / Направление',
    specializationPlaceholder: 'Например: Электроинженерия',
    fromYear: 'С какого года',
    toYear: 'По какой год',
    present: 'По настоящее время',
    addMore: 'Добавить учебное заведение',
    hint: 'Необязательно. Указанное образование сохранится в CV, если пусто — AI создаст сам.',
    empty: 'Учебные заведения не указаны — AI создаст образование сам.',
  },

  workExperience: {
    label: 'Опыт работы',
    placeLabel: 'Место работы',
    placePlaceholder: 'Например: Ташкентский Тракторный Завод',
    positionLabel: 'Должность',
    positionPlaceholder: 'Например: Электросварщик, Слесарь, Водитель...',
    fromYear: 'С какого года',
    toYear: 'По какой год',
    present: 'Настоящее время',
    addMore: 'Добавить место работы',
    hint: 'Необязательно. Указанные места сохранятся в CV. Остальные годы AI дополнит сам.',
    empty: 'Места работы не указаны — AI создаст полный опыт сам.',
    errorFromGreater: 'Год начала не может быть позже года окончания',
  },

  languageSelector: {
    label: 'Знание языков',
    languagePlaceholder: 'Язык',
    levelPlaceholder: 'Уровень',
    addMore: 'Добавить язык',
    hint: 'В CV будет отображено в этом порядке. Например: {example}',
    groupNative: 'Родной',
    groupCefr: 'Уровни CEFR',
    groupFree: 'Свободно',
    native: 'Родной язык (Native)',
    a1: 'A1 — Начальный',
    a2: 'A2 — Элементарный',
    b1: 'B1 — Средний',
    b2: 'B2 — Выше среднего',
    c1: 'C1 — Продвинутый',
    c2: 'C2 — В совершенстве',
    conversational: 'Разговорный',
    confident: 'Уверенный',
    fluent: 'Свободно',
    langs: {
      uzbek: 'Узбекский',
      russian: 'Русский',
      english: 'Английский',
      korean: 'Корейский',
      turkish: 'Турецкий',
      german: 'Немецкий',
      french: 'Французский',
      italian: 'Итальянский',
      spanish: 'Испанский',
      arabic: 'Арабский',
      chinese: 'Китайский',
      japanese: 'Японский',
      polish: 'Польский',
      czech: 'Чешский',
      kazakh: 'Казахский',
      kyrgyz: 'Киргизский',
      tajik: 'Таджикский',
      persian: 'Персидский (Дари)',
      ukrainian: 'Украинский',
      turkmen: 'Туркменский',
    },
  },

  botSurveys: {
    title: 'Анкеты из бота',
    searchPlaceholder: 'Имя, телефон, телеграм...',
    fullName: 'ФИО',
    phone: 'Телефон',
    purpose: 'Цель',
    destination: 'Страна',
    telegram: 'Телеграм',
    date: 'Дата',
    actions: 'Действия',
    view: 'Просмотр',
    delete: 'Удалить',
    confirmDelete: 'Вы хотите удалить эту анкету?',
    confirmDeleteTitle: 'Подтверждение',
    deleteSuccess: 'Анкета удалена',
    detailTitle: 'Детали анкеты',
    dob: 'Дата рождения',
    timeline: 'Сроки выезда',
    education: 'Образование',
    specialty: 'Специальность',
    workExp: 'Опыт работы',
    intlExp: 'Международный опыт',
    languages: 'Языки',
    criminal: 'Судимость',
    visa: 'Отказ в визе',
    travelBan: 'Запрет на выезд',
    marital: 'Семейное положение',
    jobInterest: 'Интерес к работе',
    profession: 'Желаемая профессия',
    wishes: 'Личные пожелания',
  },

  network: {
    serverError: 'Ошибка подключения к серверу',
    forbidden: 'Доступ запрещён',
    offline: 'Нет соединения — обновится автоматически',
    slow: 'Медленное соединение, повторная попытка...',
  },

  email: {
    dialogTitle: 'Отправить email выбранным вакансиям',
    senderLabel: 'С какого email отправить?',
    customSender: 'Ввести вручную',
    customEmailPh: 'ваш@email.com',
    customPassPh: 'Gmail App Password',
    saveSender: 'Сохранить на будущее',
    appPasswordHint: 'Gmail > Безопасность > 2FA > App Passwords',
    templateLabel: 'Шаблон',
    selectTemplate: 'Выберите шаблон (необязательно)',
    saveAsTemplate: 'Сохранить как шаблон',
    deleteTemplate: 'Удалить шаблон',
    subjectLabel: 'Тема',
    subjectPh: 'Например: Предложение о сотрудничестве',
    bodyLabel: 'Текст',
    bodyPh: 'Здравствуйте,\nМы — агентство Oasis Visa...',
    recipientsLabel: 'Получатели',
    noEmail: 'нет email',
    more: 'ещё',
    noEmailWarn: 'У {count} вакансий нет email — им не будет отправлено',
    sendBtn: 'Отправить ({count})',
    sentAll: 'Успешно отправлено: {count}',
    sentPartial: 'Отправлено: {ok}, с ошибкой: {fail}',
    sentFailed: 'Не удалось отправить',
    templateNamePh: 'Название шаблона',
    templateNameRequired: 'Введите название шаблона',
    templateSaved: 'Шаблон сохранён',
    templateDeleted: 'Шаблон удалён',
    confirmDeleteTpl: 'Удалить шаблон?',
    subjectBodyRequired: 'Сначала заполните тему и текст',
    markDefault: 'Сделать шаблоном по умолчанию',
    bulkEmailBtn: 'Отправить email',
  },

  analytics: {
    myStatsTitle: 'Моя статистика',
    employeesTitle: 'Мониторинг сотрудников',
    employeesSub: 'Кто онлайн, кто и сколько работает — в реальном времени',
    day: 'Сегодня',
    week: 'Неделя',
    month: 'Месяц',
    activeTime: 'Активное время',
    realWorkTime: 'Реальное рабочее время (без простоев)',
    vacancies: 'Вакансии',
    partnersAdded: 'Добавлено партнёров',
    partners: 'Партнёры',
    clientsWorked: 'Клиенты',
    clientsAssigned: 'Новые клиенты',
    stageChanged: 'Переведено по этапу',
    completed: 'Завершено',
    online: 'Онлайн',
    onlineNow: 'Сейчас онлайн',
    lastSeen: 'Последняя активность',
    totalHours: 'Общие часы',
    employee: 'Сотрудник',
    activity: 'Активность',
    roleAdmin: 'Администратор',
    roleEmployee: 'Сотрудник',
    noEmployees: 'Сотрудники не найдены',
    neverLoggedIn: 'Никогда не входил',
    justNow: 'только что',
    minutesAgo: '{n} мин. назад',
    hoursAgo: '{n} ч. назад',
    daysAgo: '{n} дн. назад',
    lvlInactive: 'Неактивен',
    lvlLow: 'Низкий',
    lvlMedium: 'Средний',
    lvlGood: 'Хороший',
    lvlHigh: 'Высокий',
    lvlElite: 'Элита',
  },
  pwa: {
    title: "Установите приложение",
    desc: "Установите на телефон — открывается быстрее и работает без браузера.",
    iosHint: "Нажмите “Share” внизу, затем “Add to Home Screen”.",
    install: "Установить",
    later: "Позже",
  },
  cases: {
    title: "Дела (Cases)",
    newCase: "Создать новое дело",
    dashboard: "Что ждёт меня? (Дашборд)",
    refresh: "Обновить",
    criticalRisks: "CRITICAL Риски",
    noCriticalRisks: "В данный момент нет открытых CRITICAL рисков",
    pendingApprovals: "Ожидающие утверждения",
    noPendingApprovals: "Нет дел, ожидающих утверждения",
    stagnantTasks: "Зависшие задачи (>3 дней)",
    noStagnantTasks: "Нет зависших задач",
    caseDetail: "Карточка дела",
    client: "Клиент",
    country: "Страна",
    serviceType: "Тип услуги",
    status: "Статус",
    targetDate: "Срок сдачи",
    actions: "Действия",
    open: "Открыть",
    changeStatus: "Изменить статус",
    selectStatus: "Выберите статус",
    transition: "Перейти",
    tabs: {
      documents: "Матрица документов",
      facts: "Факты",
      risks: "Риски",
      approvals: "Утверждения"
    },
    doc: {
      document: "Документ",
      requirement: "Требование",
      status: "Статус",
      file: "Файл",
      deadline: "Дедлайн",
      mandatory: "Обязательно",
      conditional: "Условно",
      no: "Нет",
      download: "Скачать",
      noFile: "Нет файла"
    },
    fact: {
      key: "Ключ",
      value: "Значение",
      source: "Источник",
      level: "Уровень",
      status: "Статус",
      checkedAt: "Проверено"
    },
    risk: {
      closeRisk: "Закрыть риск",
      closedBy: "Закрыт",
      noRisks: "Риски не найдены",
      reason: "Причина закрытия",
      reasonPlaceholder: "Например: Паспорт проверен...",
      submitClose: "Закрыть и разблокировать"
    },
    approval: {
      step: "Этап",
      status: "Статус",
      requestedAt: "Запрошено",
      decidedAt: "Решено",
      note: "Примечание",
      approve: "Утвердить",
      reject: "Отклонить",
      pending: "Ожидает",
      approved: "Утверждено",
      rejected: "Отклонено"
    },
    statuses: {
      yangi: "Новый",
      hujjat_yigilmoqda: "Сбор документов",
      hujjatlar_tayyor: "Документы готовы",
      jonatildi: "Отправлено",
      viza_kutilmoqda: "Ожидание визы",
      viza_oldi: "Виза получена",
      bekor: "Отменено",
      stopped_by_risk: "Остановлено (риск)"
    }
  },
  dv: {
    title: "Анкеты Green Card (DV)",
    subtitle: "Анкета DS-5501 клиента как шаблон: к открытию регистрации данные, фото и скан паспорта уже проверены и готовы. Заявка подаётся только на dvprogram.state.gov, вместе с клиентом.",
    yangi: "Новая анкета",
    qidirish: "Имя, паспорт, телефон, email или Confirmation Number",
    meniki: "Только мои",
    ta: "шт.",
    bosh: "Анкет пока нет",
    ishtirokchi: "Участник",
    ismsiz: "(без имени)",
    telefon: "Телефон",
    crmMijoz: "Клиент CRM",
    tayyorlik: "Готовность",
    xato: "ошибок",
    xatosiz: "без ошибок",
    holati: "Статус",
    oila: "Семья",
    yangilangan: "Обновлено",
    crmdan: "Из клиента CRM",
    boshAnketa: "Пустая анкета",
    mijozIzla: "Поиск по фамилии, имени или паспорту",
    crmdanIzoh: "Имя, дата рождения, паспорт, телефон, email и адрес заполняются из CRM — сверьте каждое с паспортом. Отчество в Middle Name не пишется.",
    boshIzoh: "Если клиента ещё нет в CRM — позже анкету можно привязать к клиенту.",
    ochish: "Открыть",
    holat: {
      qoralama: "Черновик",
      tayyor: "Готово",
      topshirildi: "Подано",
      yutdi: "Выиграл",
      yutmadi: "Не выиграл",
      bekor: "Отменено"
    },
    royxat: "Список",
    bekorQil: "Отменить изменения",
    saqlash: "Сохранить",
    bekorQilish: "Отменить анкету",
    tiklash: "Восстановить",
    ochirish: "Удалить навсегда",
    bekorQilingan: "Анкета отменена — для редактирования сначала восстановите (меню ⋯).",
    oilaAzolari: "Члены семьи",
    keyingi: "Далее",
    tekshirish: "Проверка",
    olibTashlash: "Убрать из списка",
    turmushQosh: "Добавить супруга(у)",
    farzandQosh: "Добавить ребёнка",
    tuzatishKerak: "Нужно исправить",
    xatoYoq: "Ошибок нет — анкета готова к регистрации.",
    tekshiribKoring: "Проверьте",
    shpargalka: "Шпаргалка (в порядке официальной формы)",
    yangilash: "Обновить",
    nusxalash: "Копировать",
    shpIzoh: "В день регистрации форма на dvprogram.state.gov заполняется по этому тексту поле за полем. Даты — как в форме: МЕСЯЦ / ДЕНЬ / ГОД.",
    saqlanmagan: "Есть несохранённые изменения — шпаргалка показывает последнее сохранённое состояние.",
    tayyor: "готово",
    topshirishgaTayyor: "Готово к регистрации",
    mijozBogla: "Привязать к клиенту CRM",
    topshirish: "Подача",
    topshirishIzoh: "16-значный Confirmation Number после отправки на официальном сайте — результат проверяется только по нему.",
    raqamniYangila: "Обновить номер",
    topshirildiDeb: "Отметить как поданное",
    natija: "Результат",
    kutilmoqda: "Ожидается",
    izoh: "Заметка сотрудника",
    izohPh: "Клиенту не видна",
    yaratgan: "Создал",
    ozgartirgan: "Изменил",
    saqlangan: "Сохранено",
    ozgarishYoq: "Изменений нет — всё сохранено",
    saqlanmaganQisqa: "Есть несохранённые изменения",
    saqlandi: "Сохранено",
    saqlandiTayyor: "Сохранено — анкета готова к регистрации",
    xatoQoldi: "ошибок осталось"
  }
}
